var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',_vm._g(_vm._b({attrs:{"danger":""},on:{"click":_vm.onClicked}},'btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm._f("trans")('Delete')))])
}
var staticRenderFns = []

export { render, staticRenderFns }